export function initMainHomeAdvantage() {
  const root = document.querySelector("[data-main-advantage]");
  if (!root || typeof window.Swiper !== "function") {
    return;
  }

  const textEl = root.querySelector(".swiper-advantage-text");
  const imageEl = root.querySelector(".swiper-advantage-image");
  const progressEl = root.querySelector(".progress-container");
  const prevEl = root.querySelector(".advantage-prev");
  const nextEl = root.querySelector(".advantage-next");

  if (!textEl || !imageEl || !progressEl || !prevEl || !nextEl) {
    return;
  }

  function updatePagination(swiper) {
    const totalSlides = swiper.slides.length;
    const currentIndex = swiper.realIndex + 1;
    const cur = String(currentIndex).padStart(2, "0");
    const tot = String(totalSlides).padStart(2, "0");
    const ratio = totalSlides > 1 ? currentIndex / totalSlides : 1;

    root.querySelectorAll(".pagi_wrap").forEach((el) => {
      el.innerHTML = `<span class="current-page">${cur}</span> / <span class="total-page">${tot}</span>`;
    });

    progressEl.style.setProperty("--advantage-progress", ratio);
  }

  const imageSwiper = new window.Swiper(imageEl, {
    loop: false,
    effect: "fade",
    fadeEffect: { crossFade: true },
    speed: 1200,
    allowTouchMove: true,
  });

  const textSwiper = new window.Swiper(textEl, {
    loop: false,
    effect: "fade",
    fadeEffect: { crossFade: true },
    speed: 1200,
    autoplay: {
      delay: 4500,
      disableOnInteraction: false,
    },
    allowTouchMove: true,
    navigation: {
      nextEl,
      prevEl,
    },
    controller: {
      control: imageSwiper,
    },
    on: {
      init(swiper) {
        updatePagination(swiper);
      },
      slideChange(swiper) {
        updatePagination(swiper);
      },
      transitionEnd(swiper) {
        updatePagination(swiper);
      },
    },
  });

  imageSwiper.controller.control = textSwiper;
}

const MAIN_INTRO_LOCK_KEY = "main-intro";

// 인트로(willem) 로딩 애니메이션 → 끝에서 no-main--hero 스와이퍼로 핸드오프.
export function initMainHomeHero() {
  const heroSwiper = createMainVisualSwiper();
  const intro = document.querySelector(".willem-header.no-main--intro");
  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  // 인트로 마크업이 없거나(다른 페이지) · 모션 최소화 · GSAP 미로드면 바로 hero 노출.
  if (!intro || reduceMotion || typeof window.gsap === "undefined") {
    intro?.remove();
    startHero(heroSwiper);
    return;
  }

  playIntro(intro, () => {
    intro.remove();
    startHero(heroSwiper);
    // 확대→hero 전환이 끝난 "뒤"에 히어로 텍스트가 등장.
    revealHeroText();
  });
}

function revealHeroText() {
  const lines = document.querySelectorAll(".no-main--hero .title__line");
  if (!lines.length || typeof window.gsap === "undefined") {
    return;
  }
  // 라인별로 위→아래 순서(DOM 순서)대로, 마스크 아래에서 위로 올라오며 등장.
  window.gsap.to(lines, {
    yPercent: 0,
    duration: 1.1,
    ease: "power3.out",
    stagger: 0.16,
    delay: 0.2,
  });
}

function createMainVisualSwiper() {
  const el = document.querySelector(".main-visual-swiper");
  if (!el || typeof window.Swiper !== "function") {
    return null;
  }

  return new window.Swiper(el, {
    loop: true,
    speed: 1000,
    effect: "fade",
    fadeEffect: { crossFade: true },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      prevEl: el.querySelector(".main-visual-prev"),
      nextEl: el.querySelector(".main-visual-next"),
    },
    pagination: {
      el: el.querySelector(".main-visual-pagi"),
      clickable: true,
    },
    on: {
      // 인트로가 끝나기 전까지는 자동재생을 멈춰둔다.
      init() {
        this.autoplay?.stop();
      },
    },
  });
}

function startHero(swiper) {
  if (swiper?.el) {
    // 프로그레스 채움 시간을 autoplay 듀레이션에 맞추고, hero 시작 후에만 채워지게 한다.
    const delay = swiper.params?.autoplay?.delay ?? 5000;
    swiper.el.style.setProperty("--pagi-dur", delay / 1000 + "s");
    swiper.el.classList.add("is-started");
  }
  swiper?.autoplay?.start();
}

function playIntro(container, onComplete) {
  const { gsap } = window;
  const loadingLetter = container.querySelectorAll(".willem__letter");
  const box = container.querySelectorAll(".willem-loader__box");
  const growingImage = container.querySelectorAll(".willem__growing-image");
  const headingStart = container.querySelectorAll(".willem__h1-start");
  const headingEnd = container.querySelectorAll(".willem__h1-end");
  const brandImgs = container.querySelectorAll(".willem__brand");
  const heroLines = document.querySelectorAll(".no-main--hero .title__line");
  // is--4(main-hero01)는 마지막에 확대되며 남아야 하므로 페이드아웃 대상에서 제외한다.
  const coverImageExtra = container.querySelectorAll(
    ".willem__cover-image-extra:not(.is--4)",
  );

  // 인트로 동안 스크롤 잠금 (app.js 의 전역 락 헬퍼 재사용).
  window.__lockGlobalScroll?.(MAIN_INTRO_LOCK_KEY);

  const tl = gsap.timeline({
    defaults: { ease: "expo.inOut" },
    onStart: () => {
      container.classList.remove("is--hidden");
    },
    onComplete: () => {
      window.__unlockGlobalScroll?.(MAIN_INTRO_LOCK_KEY);
      onComplete?.();
    },
  });

  // 히어로 타이틀 라인은 인트로 시작 시 마스크 아래로 숨겨둔다(확대 끝에서 라인별 등장).
  if (heroLines.length) {
    tl.set(heroLines, { yPercent: 110 }, 0);
  }
  // H·B 브랜드 이미지를 순서대로(stagger) 마스크 아래에서 위로 — 부드러운 감속 ease.
  if (brandImgs.length) {
    tl.fromTo(
      brandImgs,
      { yPercent: 120 },
      {
        yPercent: 0,
        duration: 1.5,
        stagger: 0.22,
        ease: "power3.out", // 기본 expo.inOut(딱딱함) 대신 부드럽게 감속
      },
      0,
    );
  }
  if (loadingLetter.length) {
    tl.from(loadingLetter, { yPercent: 100, stagger: 0.025, duration: 1.25 });
  }
  if (box.length) {
    tl.fromTo(box, { width: "0em" }, { width: "1em", duration: 1.25 }, "<1.25");
  }
  if (growingImage.length) {
    tl.fromTo(
      growingImage,
      { width: "0%" },
      { width: "100%", duration: 1.25 },
      "<",
    );
  }
  if (headingStart.length) {
    tl.fromTo(
      headingStart,
      { x: "0em" },
      { x: "-0.05em", duration: 1.25 },
      "<",
    );
  }
  if (headingEnd.length) {
    tl.fromTo(headingEnd, { x: "0em" }, { x: "0.05em", duration: 1.25 }, "<");
  }
  if (coverImageExtra.length) {
    tl.fromTo(
      coverImageExtra,
      { opacity: 1 },
      { opacity: 0, duration: 0.05, ease: "none", stagger: 0.32 },
      "-=0.05",
    );
  }
  // 이미지 풀스크린 확대 — 더 빠르고 부드럽게.
  if (growingImage.length) {
    tl.to(
      growingImage,
      { width: "100vw", height: "100dvh", duration: 1.2, ease: "power3.inOut" },
      "<0.9",
    );
  }
  if (box.length) {
    tl.to(box, { width: "110vw", duration: 1.2, ease: "power3.inOut" }, "<");
  }

  // 마지막: 오버레이를 확대 끝과 겹쳐 페이드아웃 → 그 아래 no-main--hero 로 매끄럽게 인계.
  // (히어로 텍스트는 인트로 종료 후 revealHeroText 에서 등장)
  tl.to(container, { opacity: 0, duration: 0.5, ease: "power2.out" }, "-=0.35");
}

// no-main--about: 섹션을 100svh 로 고정(pin).
//   1) 진입 → "공간을 넘어" 카피가 검은색으로 먼저 등장(핀 전 1회)
//   2) 핀 + 스크럽 → 검정 컬럼이 왼→오로 차오르며 화면을 덮음 (스크롤에 물림)
//   3) 검정으로 다 덮이면 → 그 검정 위에서 스크롤에 물려 순차 등장:
//      좌측 타이틀 마스크 등장 + 흰 곡선 draw + dot/라벨 하나씩 팝 + 빨강 dot 리플.
//   초기 숨김(그래프 레이어 opacity0, 헤딩 translateY, dot scale0, path dashoffset)은 SCSS 소유.
export function initMainAboutBlocks() {
  const section = document.querySelector("[data-about-blocks]");
  if (
    !section ||
    typeof window.gsap === "undefined" ||
    typeof window.ScrollTrigger === "undefined"
  ) {
    return;
  }
  const blocks = section.querySelectorAll(".about__block");
  const copy = section.querySelector(".about__copy");
  const graph = section.querySelector("[data-about-graph]");
  if (!blocks.length) return;

  // 모션 최소화: 핀/스크럽 없이 둔다. (그래프는 SCSS 가 검정 위 최종 상태로 표시)
  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  // 1) 카피: 섹션 진입 시 문자 단위 마스크 + 아래 -> 위 stagger.
  if (copy) {
    const chars = splitAboutCopyChars(copy);
    if (chars.length) {
      gsap.fromTo(
        copy,
        { opacity: 0 },
        {
          opacity: 1,
          duration: 0.24,
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top 52%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );

      gsap.fromTo(
        chars,
        { yPercent: 115, opacity: 0 },
        {
          yPercent: 0,
          opacity: 1,
          duration: 0.88,
          ease: "power3.out",
          stagger: 0.055,
          scrollTrigger: {
            trigger: section,
            start: "top 52%",
            toggleActions: "play none none none",
            once: true,
          },
        },
      );
    }
  }

  // 초기 숨김(레이어 clip-path 가림 · dot scale0 · 라벨 opacity0)은 SCSS 소유.
  const headingLines = graph
    ? graph.querySelectorAll(".graph__h-line > span")
    : [];
  const points = graph ? graph.querySelectorAll(".graph__point") : [];
  const redDot = graph ? graph.querySelector(".graph__dot--ripple") : null;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top top",
      end: "+=220%",
      pin: true,
      scrub: 0.5,
      anticipatePin: 1,
    },
  });

  // PHASE 1) 블럭 채움 — 왼→오로 풀하이트로 차오르며 검정으로 덮음 (t 0 → ≈2.0)
  tl.to(
    blocks,
    {
      scaleY: 1,
      transformOrigin: "bottom center",
      ease: "none",
      duration: 0.8,
      stagger: { each: 0.3, from: "start" },
    },
    0,
  );

  // PHASE 2) 검정 위에 그래프 등장
  if (graph) {
    const g = 2.05; // 검정 완료 직후
    const wipeDuration = 1.4;
    // 각 dot 의 x 좌표(%) — clip-path 의 오른쪽 inset 이 해당 값 아래로 줄었을 때 팝
    const POP_AT = [0.431, 0.676, 0.828];

    // 막대·곡선·점·라벨 전부를 왼쪽부터 쭉 닦아냄 (오른쪽 inset 100→0)
    tl.fromTo(
      graph,
      { clipPath: "inset(0 100% 0 0)" },
      {
        clipPath: "inset(0 0% 0 0)",
        duration: wipeDuration,
        ease: "power2.out",
      },
      g,
    );

    // 좌측 타이틀: 한 줄씩 아래→위로 마스크 등장 (와이프와 함께)
    if (headingLines.length) {
      tl.fromTo(
        headingLines,
        { yPercent: 110 },
        { yPercent: 0, duration: 0.9, ease: "power3.out", stagger: 0.18 },
        g + 0.2,
      );
    }

    // 포인트 하나씩 — 와이프가 각 dot 의 x 위치를 지날 때 팝 + 라벨 슬라이드업
    points.forEach((pt, i) => {
      const dot = pt.querySelector(".graph__dot");
      const label = pt.querySelector(".graph__label");
      const at = g + (POP_AT[i] ?? 0.828) * wipeDuration;
      if (dot) {
        tl.to(dot, { scale: 1, duration: 0.3, ease: "power2.out" }, at);
      }
      if (label) {
        tl.to(
          label,
          { opacity: 1, y: 0, duration: 0.4, ease: "power2.out" },
          at + 0.08,
        );
      }
    });

    // 빨강 dot 리플(무한)
    if (redDot) {
      const lastAt = g + (POP_AT[points.length - 1] ?? 0.828) * wipeDuration;
      tl.call(
        () => {
          redDot.classList.add("is-rippling");
        },
        null,
        lastAt + 0.3,
      );
    }
  }

  requestAnimationFrame(() => {
    ScrollTrigger.refresh();
  });
}

function splitAboutCopyChars(copyEl) {
  return splitTextWithMask(
    copyEl,
    "about__copy-mask",
    "about__copy-char",
    "aboutSplitReady",
  );
}

function splitTextWithMask(el, maskClass, charClass, readyKey) {
  if (!el) {
    return [];
  }
  if (el.dataset[readyKey] === "1") {
    return Array.from(el.querySelectorAll(`.${charClass}`));
  }

  const originalNodes = Array.from(el.childNodes);
  if (!originalNodes.length) {
    return [];
  }

  const frag = document.createDocumentFragment();
  originalNodes.forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      const normalized = (node.textContent ?? "").replace(/\s+/g, " ").trim();
      if (!normalized) {
        return;
      }
      [...normalized].forEach((ch) => {
        if (ch === " ") {
          frag.appendChild(document.createTextNode("\u00A0"));
          return;
        }
        const mask = document.createElement("span");
        mask.className = maskClass;
        // 인라인 스타일로 직접 고정 — 섹션별 .title span { display:flex } 등 덮어쓰기 방지
        mask.style.cssText =
          "display:inline-block;overflow:hidden;vertical-align:top;";
        const char = document.createElement("span");
        char.className = charClass;
        char.style.cssText = "display:inline-block;";
        char.textContent = ch;
        mask.appendChild(char);
        frag.appendChild(mask);
      });
      return;
    }
    if (node.nodeType === Node.ELEMENT_NODE && node.nodeName === "BR") {
      frag.appendChild(document.createElement("br"));
    }
  });

  el.textContent = "";
  el.appendChild(frag);
  el.dataset[readyKey] = "1";

  return Array.from(el.querySelectorAll(`.${charClass}`));
}

function wrapInMask(el, maskClass) {
  if (!el || el.parentNode.classList.contains(maskClass)) return;
  const mask = document.createElement("span");
  mask.className = maskClass;
  mask.style.cssText = "display:block; overflow:hidden;";
  el.parentNode.insertBefore(mask, el);
  mask.appendChild(el);
}

export function initMainValueReveal() {
  const section = document.querySelector(".no-main--value");
  if (
    !section ||
    typeof window.gsap === "undefined" ||
    typeof window.ScrollTrigger === "undefined"
  ) {
    return;
  }

  const titleTopH2 = section.querySelector(".title-top h2");
  const titleBottomH2 = section.querySelector(".title-bottom h2");
  const imageLis = Array.from(section.querySelectorAll(".grid-img > li"));
  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;

  if (reduceMotion) return;

  // 제목: 글자 단위 split + 아래→위 stagger
  [
    { el: titleTopH2, key: "vtop" },
    { el: titleBottomH2, key: "vbot" },
  ].forEach(({ el, key }) => {
    if (!el) return;
    const chars = splitTextWithMask(el, "mh2-mask", "mh2-char", key);
    if (!chars.length) return;
    // 부모 h2는 미리 보이게 전환하고, 실제 숨김 상태는 split 글자가 담당
    // (visibility hidden 고착으로 영구 숨김되는 케이스 방지)
    el.style.visibility = "visible";
    el.style.opacity = "1";
    gsap.set(chars, { yPercent: 115, opacity: 0 });
    gsap.to(chars, {
      yPercent: 0,
      opacity: 1,
      duration: 0.82,
      ease: "power3.out",
      stagger: 0.042,
      scrollTrigger: {
        trigger: section,
        start: "top 62%",
        toggleActions: "play none none none",
        once: true,
        invalidateOnRefresh: true,
      },
    });
  });

  // 이미지: clip-path 아래→위 차오름, 좌→우 stagger 순차
  gsap.set(imageLis, {
    clipPath: "inset(100% 0% 0% 0%)",
    opacity: 0,
    visibility: "hidden",
  });
  gsap.to(imageLis, {
    clipPath: "inset(0% 0% 0% 0%)",
    opacity: 1,
    visibility: "visible",
    duration: 1.4,
    ease: "power2.out",
    stagger: 0.2,
    scrollTrigger: {
      trigger: section.querySelector(".grid-img"),
      start: "top 75%",
      toggleActions: "play none none none",
      once: true,
      invalidateOnRefresh: true,
    },
  });
}

export function initMainHeadingsReveal() {
  if (
    typeof window.gsap === "undefined" ||
    typeof window.ScrollTrigger === "undefined"
  ) {
    return;
  }
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const selectors = [
    ".no-main--service .title h2",
    ".no-main--pf .title h2",
    ".no-main--pf2 .title h2",
    ".no-main--count .no-main--count__heading",
    ".no-main--why .title h2",
    ".no-main--process .title h2",
    ".no-main--magazine .title h2",
    ".no-main--news .title h2",
    ".no-main--contact .contact-copy h2",
  ];

  selectors.forEach((selector, i) => {
    const h2 = document.querySelector(selector);
    if (!h2) return;

    const chars = splitTextWithMask(h2, "mh2-mask", "mh2-char", `mh2${i}`);
    if (!chars.length) return;

    // 부모 h2는 미리 보이게 전환하고, 숨김/등장은 split 글자가 담당
    h2.style.visibility = "visible";
    h2.style.opacity = "1";
    gsap.set(chars, { yPercent: 115, opacity: 0 });

    // h2 자체보다 섹션(closest section)을 트리거로 써야 Lenis 환경에서 안정적으로 발화
    const triggerEl = h2.closest("section") ?? h2.parentNode;

    gsap.to(chars, {
      yPercent: 0,
      opacity: 1,
      duration: 0.72,
      ease: "power3.out",
      stagger: 0.038,
      scrollTrigger: {
        trigger: triggerEl,
        start: "top 62%",
        toggleActions: "play none none none",
        once: true,
        invalidateOnRefresh: true,
      },
    });
  });
}

export function initMainStoryReveal() {
  const section = document.querySelector(".no-main--story");
  if (
    !section ||
    typeof window.gsap === "undefined" ||
    typeof window.ScrollTrigger === "undefined"
  ) {
    return;
  }

  const h2 = section.querySelector(".title h2");
  if (!h2) return;

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (reduceMotion) return;

  // h2를 overflow:hidden mask span으로 감싸서 아래→위 등장 클리핑
  const mask = document.createElement("span");
  mask.className = "story__h2-mask";
  mask.style.cssText = "display:block; overflow:hidden;";
  h2.parentNode.insertBefore(mask, h2);
  mask.appendChild(h2);

  h2.style.visibility = "visible";
  h2.style.opacity = "1";
  gsap.set(h2, { yPercent: 105 });
  gsap.to(h2, {
    yPercent: 0,
    duration: 1.1,
    ease: "power3.out",
    scrollTrigger: {
      trigger: mask,
      start: "top 80%",
      toggleActions: "play none none none",
      once: true,
      invalidateOnRefresh: true,
    },
  });

  // 그리드 이미지: main → sub-1 → sub-2 → wide 순으로 clip-path 아래→위 + 내부 이미지 scale-down
  const gridFigures = [
    section.querySelector(".grid-cont__main"),
    section.querySelector(".grid-cont__sub--1"),
    section.querySelector(".grid-cont__sub--2"),
    section.querySelector(".grid-cont__wide"),
  ].filter(Boolean);

  gsap.set(gridFigures, {
    clipPath: "inset(100% 0% 0% 0%)",
    visibility: "hidden",
  });
  gridFigures.forEach((fig) => {
    const img = fig.querySelector("img");
    if (img) gsap.set(img, { scale: 1.08 });
  });

  gsap.to(gridFigures, {
    clipPath: "inset(0% 0% 0% 0%)",
    visibility: "visible",
    duration: 1.3,
    ease: "power2.out",
    stagger: 0.18,
    scrollTrigger: {
      trigger: section.querySelector(".grid-cont"),
      start: "top 72%",
      toggleActions: "play none none none",
      once: true,
      invalidateOnRefresh: true,
    },
  });
  gridFigures.forEach((fig, i) => {
    const img = fig.querySelector("img");
    if (!img) return;
    gsap.to(img, {
      scale: 1,
      duration: 1.6,
      delay: i * 0.18,
      ease: "power2.out",
      scrollTrigger: {
        trigger: section.querySelector(".grid-cont"),
        start: "top 72%",
        toggleActions: "play none none none",
        once: true,
        invalidateOnRefresh: true,
      },
    });
  });
}

export function initMainContactReveal() {
  const section = document.querySelector(".no-main--contact");
  if (
    !section ||
    typeof window.gsap === "undefined" ||
    typeof window.ScrollTrigger === "undefined"
  ) {
    return;
  }
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  // CSS 위치 기반 좌→우 순서: left:2% → left:10% → left:12% → right:19% → right:10% → right:2%
  const orderedSelectors = [
    ".visual-img--2",
    ".visual-img--1",
    ".visual-img--3",
    ".visual-img--4",
    ".visual-img--6",
    ".visual-img--5",
  ];

  const figures = orderedSelectors
    .map((sel) => section.querySelector(sel))
    .filter(Boolean);

  if (!figures.length) return;

  figures.forEach((figure) => {
    figure.style.visibility = "visible";
  });
  gsap.set(figures, { opacity: 0, filter: "blur(18px)", scale: 1.04 });
  gsap.to(figures, {
    opacity: 1,
    filter: "blur(0px)",
    scale: 1,
    duration: 1.1,
    ease: "power2.out",
    stagger: 0.18,
    scrollTrigger: {
      trigger: section,
      start: "top 68%",
      toggleActions: "play none none none",
      once: true,
      invalidateOnRefresh: true,
    },
  });
}

function createMagazineSwiper(el, isActive) {
  const slideCount = el.querySelectorAll(".swiper-slide").length;
  const sw = new window.Swiper(el, {
    loop: slideCount > 4,
    centeredSlides: false,
    speed: 1800,
    spaceBetween: 24,
    slidesPerGroup: 1,
    slidesPerView: "auto",
    autoplay:
      slideCount > 1 ? { delay: 3000, disableOnInteraction: false } : false,
    breakpoints: {
      320: { spaceBetween: 12 },
      1024: { spaceBetween: 24 },
    },
  });
  if (!isActive && sw.autoplay) sw.autoplay.stop();
  return sw;
}

export function initMainMagazineSlide() {
  const section = document.querySelector(".no-main--magazine");
  if (!section || typeof window.Swiper !== "function") {
    return;
  }

  const panels = [...section.querySelectorAll("[data-magazine-panel]")];

  // 레거시(단일 슬라이드) 마크업 호환
  if (!panels.length) {
    const el = section.querySelector(".magazine-slide");
    if (el) createMagazineSwiper(el, true);
    return;
  }

  const tabs = [...section.querySelectorAll("[data-magazine-tab]")];
  const swipers = new Map();
  panels.forEach((panel) => {
    const el = panel.querySelector(".magazine-slide");
    if (el)
      swipers.set(
        panel,
        createMagazineSwiper(el, panel.classList.contains("is-active")),
      );
  });

  const reduceMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  const canAnimate = typeof window.gsap !== "undefined" && !reduceMotion;

  // 애니메이션 불가 시 클립 상태를 즉시 해제(이미지가 가려지지 않도록)
  if (!canAnimate) {
    section.classList.add("is-magazine-revealed");
  }

  // 패널의 썸네일을 좌→우 순서로, 아래에서 위로(clip-path) 차오르게 리빌
  const revealPanel = (panel) => {
    if (!canAnimate) return;
    section.classList.add("is-magazine-revealed");

    const originals = [
      ...panel.querySelectorAll(
        ".swiper-slide:not(.swiper-slide-duplicate) .magazine-card__figure",
      ),
    ];
    if (!originals.length) return;

    // 시각적 좌측부터 순서대로 (루프 클론과 무관하게 위치 기준 정렬)
    originals.sort(
      (a, b) => a.getBoundingClientRect().left - b.getBoundingClientRect().left,
    );

    const dupes = [...panel.querySelectorAll(".magazine-card__figure")].filter(
      (f) => !originals.includes(f),
    );
    if (dupes.length) {
      gsap.set(dupes, { clipPath: "inset(0% 0% 0% 0%)" });
    }

    gsap.fromTo(
      originals,
      { clipPath: "inset(100% 0% 0% 0%)" },
      {
        clipPath: "inset(0% 0% 0% 0%)",
        duration: 0.85,
        ease: "power3.out",
        stagger: 0.12,
        overwrite: true,
      },
    );
  };

  const activate = (key) => {
    panels.forEach((panel) => {
      const isActive = panel.dataset.magazinePanel === key;
      panel.classList.toggle("is-active", isActive);
      panel.setAttribute("aria-hidden", isActive ? "false" : "true");

      const sw = swipers.get(panel);
      if (sw) {
        if (isActive) {
          sw.update();
          sw.autoplay?.start?.();
        } else {
          sw.autoplay?.stop?.();
        }
      }
      if (isActive) revealPanel(panel);
    });

    tabs.forEach((tab) => {
      const isActive = tab.dataset.magazineTab === key;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => activate(tab.dataset.magazineTab));
  });

  // 최초 진입 시 활성 패널(인스타그램) 썸네일 리빌
  const initialPanel =
    panels.find((p) => p.classList.contains("is-active")) || panels[0];

  if (canAnimate && typeof window.ScrollTrigger !== "undefined") {
    ScrollTrigger.create({
      trigger: section,
      start: "top 70%",
      once: true,
      onEnter: () => revealPanel(initialPanel),
    });
  }
}

export function initMainPfReveal() {
  const section = document.querySelector(".no-main--pf");
  if (
    !section ||
    typeof window.gsap === "undefined" ||
    typeof window.ScrollTrigger === "undefined"
  ) {
    return;
  }
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const swiperWrap = section.querySelector(".pf-swiper-wrap");
  if (!swiperWrap) return;

  gsap.set(swiperWrap, { opacity: 0, x: 80 });
  gsap.to(swiperWrap, {
    opacity: 1,
    x: 0,
    duration: 1.0,
    ease: "power3.out",
    scrollTrigger: {
      trigger: section,
      start: "top 55%",
      toggleActions: "play none none none",
      once: true,
      invalidateOnRefresh: true,
    },
  });
}

export function initMainPfSwiper() {
  const wrap = document.querySelector("[data-pf-swiper]");
  if (!wrap || typeof window.Swiper !== "function") {
    return;
  }

  const swiperEl = wrap.querySelector(".pf-swiper");
  const prevEl = wrap.querySelector(".pf-nav--prev");
  const nextEl = wrap.querySelector(".pf-nav--next");
  const pagiEl = wrap.querySelector(".pf-pagi");

  if (!swiperEl) {
    return;
  }

  // 최대 slidesPerView(2)보다 슬라이드가 많아야 루프가 동작한다(3개부터 양옆 미리보기 가능).
  // 그 이하(1~2개)면 루프를 꺼 빈 클론/멈춤을 방지한다.
  const slideCount = swiperEl.querySelectorAll(".swiper-slide").length;
  const enableLoop = slideCount > 2;

  new window.Swiper(swiperEl, {
    loop: enableLoop,
    // 슬라이드가 적어도(3개) 중앙 정렬 좌우 피크용 클론을 충분히 만든다.
    loopedSlides: slideCount,
    slidesPerView: 1.2,
    spaceBetween: 180,
    centeredSlides: true,
    speed: 800,
    navigation: {
      prevEl,
      nextEl,
    },
    pagination: {
      el: pagiEl,
      clickable: true,
    },
    breakpoints: {
      1920: {
        slidesPerView: 2,
        spaceBetween: 200,
        centeredSlides: true,
      },
      1640: {
        slidesPerView: 1.5,
        spaceBetween: 180,
        centeredSlides: true,
      },
      1024: {
        slidesPerView: 1.8,
        spaceBetween: 120,
        centeredSlides: true,
      },
      544: {
        slidesPerView: 1.4,
        spaceBetween: 120,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 24,
        centeredSlides: false,
      },
    },
  });
}

export function initMainPf2Reveal() {
  const section = document.querySelector(".no-main--pf2");
  if (
    !section ||
    typeof window.gsap === "undefined" ||
    typeof window.ScrollTrigger === "undefined"
  ) {
    return;
  }
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const figures = Array.from(
    section.querySelectorAll(".grid-col-3 > li figure"),
  );
  if (!figures.length) return;

  gsap.set(figures, { clipPath: "inset(100% 0% 0% 0%)", visibility: "hidden" });
  figures.forEach((fig) => {
    const img = fig.querySelector("img");
    if (img) gsap.set(img, { scale: 1.08 });
  });

  const trigger = section.querySelector(".grid-col-3");

  gsap.to(figures, {
    clipPath: "inset(0% 0% 0% 0%)",
    visibility: "visible",
    duration: 1.3,
    ease: "power2.out",
    stagger: 0.2,
    scrollTrigger: {
      trigger,
      start: "top 72%",
      toggleActions: "play none none none",
      once: true,
      invalidateOnRefresh: true,
    },
  });

  figures.forEach((fig, i) => {
    const img = fig.querySelector("img");
    if (!img) return;
    gsap.to(img, {
      scale: 1,
      duration: 1.6,
      delay: i * 0.2,
      ease: "power2.out",
      scrollTrigger: {
        trigger,
        start: "top 72%",
        toggleActions: "play none none none",
        once: true,
        invalidateOnRefresh: true,
      },
    });
  });
}
